import { Routes, mapToResolve, mapToCanActivate } from '@angular/router';
import { LawLibraryHomeComponent } from './law-library-home/law-library-home.component';
import { LawLibraryEditorComponent } from './law-library-editor/law-library-editor.component';
import { LawLibraryEditorResolver } from './law-library-editor/resolvers/law-library-editor.resolver';
import { LunaClaimValues } from '../models/user-identity.model';
import { BaseGuardService } from '../auth/guards/base-guard.service';
import { SystemPermissionGuardService } from '../auth/guards/system-permission-guard.service';
import { LawLibraryViewComponent } from './law-library-view/law-library-view.component';
import { LawLibraryPreviewComponent } from './law-library-preview/law-library-preview.component';
import { LawLibraryViewResolver } from './law-library-view/resolvers/law-library-view.resolver';

const routeGuards = [BaseGuardService, SystemPermissionGuardService];

export const LAW_LIBRARY_ROUTES: Routes = [
    {
        path: 'view/:id',
        component: LawLibraryViewComponent,
        resolve: {
            law: mapToResolve(LawLibraryViewResolver)
        }
    },
    {
        path: '',
        component: LawLibraryHomeComponent,
        children: [
            {
                path: 'create',
                data: { permission: LunaClaimValues.ManageLawLibrary },
                canActivate: mapToCanActivate(routeGuards),
                component: LawLibraryEditorComponent
            },
            {
                path: ':id',
                component: LawLibraryPreviewComponent,
                children: [
                    {
                        path: 'edit',
                        data: { permission: LunaClaimValues.ManageLawLibrary },
						canActivate: mapToCanActivate(routeGuards),
                        component: LawLibraryEditorComponent,
                        resolve: {
                            law: mapToResolve(LawLibraryEditorResolver)
                        }
                    },
                    {
                        path: '',
                        component: LawLibraryViewComponent,
                        resolve: {
                            law: mapToResolve(LawLibraryEditorResolver)
                        }
                    }
                ]
            }
        ]
    },
];
